import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FaqPageComponent } from './faq-page.component';
import { FaqhighlightPipe } from './faqhighlight.pipe';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
  declarations: [FaqPageComponent, FaqhighlightPipe],
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
  ]
})

export class FaqPageModule { }
